var RecentActivity = React.createClass({
  propTypes: {
    solutions: React.PropTypes.arrayOf(React.PropTypes.object),
    searches: React.PropTypes.arrayOf(React.PropTypes.string)
  },
  render() {

    return (
      <div>
        <h2 className="aside__title">{Labels.getLabel("Recent Activity")}</h2>

        <h5 className="aside__subtitle">
          <span className="glyphicon glyphicon-search search-icon" role="presentation"></span> {Labels.getLabel("Searches")}
        </h5>
        <RecentSearches
          className="bullet-list -indent"
          searches={this.props.searches} />

        <h5 className="aside__subtitle">
          <span className="glyphicon glyphicon-book kb-icon" role="presentation"></span> {Labels.getLabel("Solutions Viewed")}
        </h5>
        <RecentViews
          className="bullet-list -indent"
          solutions={this.props.solutions} />
      </div>
    )
  }
})